var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCpgDirectChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 325,
    height: 325,
    viewBox: "0 0 325 325",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 325,
    height: 325,
    fill: "#B5B5B5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2457_2648)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -114,
    y: -971,
    width: 1440,
    height: 4952,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -44,
    y: -166,
    width: 413,
    height: 740.852,
    rx: 44,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 162.5,
    r: 162.5,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.5 0C192.031 3.52156e-07 221.004 8.04739 246.305 23.2773C271.606 38.5072 292.279 60.3439 306.101 86.4405C319.923 112.537 326.373 141.907 324.756 171.394C323.14 200.881 313.519 229.37 296.927 253.799C280.335 278.229 257.4 297.675 230.586 310.049C203.772 322.422 174.093 327.254 144.739 324.026C115.384 320.799 87.4647 309.633 63.9799 291.729C40.4951 273.825 22.3333 249.859 11.4462 222.408L162.5 162.5V0Z",
    fill: "#333366"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -113.75,
    y: -970.75,
    width: 1439.5,
    height: 4951.5,
    stroke: "#5A5A5A",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2457_2648"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -114,
    y: -971,
    width: 1440,
    height: 4952,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpgDirectChart);
export default __webpack_public_path__ + "static/media/cpg-direct-chart.0abb717b9d5f57b51bbd59f52e1da104.svg";
export { ForwardRef as ReactComponent };